import React from 'react';
import { Popper, Paper, Typography, Box, Button } from '@mui/material';

interface AutoplayPopperProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleCloseTip: () => void;
}

declare global {
   interface Window {
      pg: any;
   }
}

export default function AutoplayPopover({
  open,
  anchorEl,
  handleCloseTip,
}: AutoplayPopperProps) {
  const [arrowRef, setArrowRef] = React.useState<HTMLElement | null>(null);

  return (
    <Popper
      /*disablePortal*/
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      modifiers={[
        {
          name: 'offset',
          options: { offset: [1, 14] },
        },
        {
          name: 'arrow',
          enabled: true,
          options: { element: arrowRef },
        },{
          name: 'flip',
          enabled: false,
        },
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            boundary: 'viewport',
            altBoundary: true,
            padding: 8,
          },
        },
        {
          name: 'hide',
          enabled: true,
        },
      ]}
      sx={{ zIndex: 9999 }}
    >
      <Box
        component="span"
        ref={setArrowRef}
        sx={{
          position: 'absolute', 
          width: '16px',
          height: '16px',
          '&::before': {
            content: "''",
            position: 'absolute',
            width: '16px',
            height: '16px',
            bgcolor: '#1D1A1A !important',
            transform: 'rotate(45deg)',
            top: '-5px',
            left: 0,
          },
        }}
      />
      <Paper
        sx={{
          padding: '12px',
          bgcolor: '#1D1A1A !important',
          color: 'white',
          maxWidth: 230,
          borderRadius: '8px',
          boxShadow: 3
        }}
      >
        <Typography variant="h6" gutterBottom
          sx={{
            fontFamily: 'Repro, sans-serif',
            fontWeight: 700,
            lineHeight: '122%',
            marginBottom: '12px',
            fontSize: '20px'
          }}>
          {window.pg?.l10n.autoplay_disabled}
        </Typography>
        <Box
          sx={{
            fontFamily: 'Repro, sans-serif',
            fontSize: '16px !important',
            fontWeight: 400,
            lineHeight: '122%',
            marginBottom: '15px'
          }}>
          {window.pg?.l10n.autoplay_off}
        </Box>
        <Box textAlign="center">
          <Button
            variant="contained"
            onClick={handleCloseTip}
            sx={{
              fontFamily: 'Repro, sans-serif',
              textTransform: 'none',
              bgcolor: 'white',
              color: 'black',
              width: '100%',
              fontSize: '16px',
              lineHeight: '122%',
              fontWeight: 400,
              borderRadius: '30px',
              padding: '10.5px 0',
              '&:hover': { bgcolor: '#f0f0f0' },
            }}
          >
            {window.pg?.l10n.dismiss}
          </Button>
        </Box>
      </Paper>
    </Popper>
  );
}
